import React, { useEffect, useState } from 'react';
import { Button, Text, View } from "../../src/Components/Themed"
import PollCampaign from '../../src/Poll';
import { ActivityIndicator, Image, Modal, useWindowDimensions } from 'react-native';
import { APIOverrides, Authenticator, Observer, PollApi, PollCampaignApi } from 'be-components';
import type { PollCampaignLeaderProps, PollCampaignProps, PollProps } from '../../src/types';
import { useColors } from '../../src/constants/useColors';
import type { AuthenticatedProps } from '../../src/Authenticator/api/types';
import ShareWidget from '../../src/Share';

type PollCampaignAppProps = {
    poll_campaign_id:string
}
const PollCampaignApp = ({ poll_campaign_id }:PollCampaignAppProps) => {
    const Colors = useColors();
    const [ auth_state, setAuthState ] = useState<any>({});
        const [ share, setShare ] = useState<{
            visible:boolean,
            share?:any
        }>({
            visible:false,
        });
    const [ authenticate, setAuthenticate ] = useState<{
        visible: boolean,
        auth_strategy_id?:string
    }>({
        visible: false
    });
    const [ campaign_data, setCampaignData ] = useState<{
        poll_campaign?:PollCampaignProps,
        polls:PollProps[],
        my_leader?:PollCampaignLeaderProps,
        loading:boolean
    }>({
        loading:false,
        polls:[]
    });
    const { poll_campaign, loading, polls, my_leader } = campaign_data
    const [ launched, setLaunched ] = useState(false);
    
    useEffect(() => {
        if(!poll_campaign_id){ return }
        startUp();
    },[poll_campaign_id]);



    const startUp = async() => {
        setCampaignData({ ...campaign_data, loading:true });
        const auth_state = await APIOverrides.start({
            env: 'PRODUCTION',
            no_cache: false
        });

        setAuthState(auth_state);
        PollCampaignApi.setEnvironment();
        const pc = await PollCampaignApi.getPollCampaignById(poll_campaign_id);
        const pls = await PollApi.getPollsByCampaignId(poll_campaign_id);
        const lds = await PollCampaignApi.getLeadersByCampaignId(poll_campaign_id, 0);
        setCampaignData({ ...campaign_data, loading:false, poll_campaign: pc, polls: pls.polls, my_leader:lds.my_leaderboard });
    }

    const { width, height } = useWindowDimensions();
    const view_mode = width > 600 ? 'desktop' : 'mobile'
    const auth_width = width > 600 ? 500: width - 20
    if(!auth_state.distinct_id){ return <></> }
    if(!launched){
        return (
            <Button float style={{ padding:0, minHeight:80 }} onPress={() => setLaunched(true)}>
                {loading || !poll_campaign ?
                <ActivityIndicator size='large' color={Colors.text.h1} style={{ alignSelf:'center' }} />
                :
                <View style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                    <View float style={{ padding:2 }}>
                        <Image
                            source={{ uri: poll_campaign.campaign_image?.url }}
                            style={{ height: 60, width:60 }}
                            resizeMode='cover'
                        />
                    </View>
                    <View transparent style={{ flex:1, marginLeft:10, marginRight:10 }}>
                        <Text theme='h1'>{poll_campaign.name}</Text>
                        {my_leader ?
                        <Text theme='description'>{my_leader.winnings.toFixed(2)} Points</Text>
                        : poll_campaign.prize_override ?
                        <Text theme='description' style={{ marginTop:10 }}>{poll_campaign.prize_override}</Text>
                        :
                        <Text theme='description' style={{ marginTop:10 }}>{polls.length} Questions - Play Now!</Text>
                        }
                    </View>
                    <Button
                        title={my_leader ? 'VIEW' : 'PLAY'}
                        type='success'
                        onPress={() => console.log('')}
                        disabled
                    />
                </View>
                }
            </Button>
        )
    }
    return (
        <Modal
            transparent
            style={{ flex:1 }}
            animationType={view_mode=='desktop'?'fade':'slide'}
        >
            <View type='blur' style={view_mode=='desktop'?{ flex:1, justifyContent:'center', alignItems:'center' }:{flex:1}}>
                <View float style={view_mode=='desktop'?{ width:600, maxHeight:height*0.9, borderRadius:0 }:{ flex:1 }}>
                    <PollCampaign
                        player_id={auth_state.player_id}
                        distinct_id={auth_state.distinct_id}
                        view_mode={view_mode}
                        poll_campaign_id={poll_campaign_id}
                        onRequestAuthenticate={() => setAuthenticate({ ...authenticate, visible: true, auth_strategy_id:poll_campaign?.auth_strategy_id })}
                        onSharePollCampaign={() => setShare({
                            visible: true,
                            share: {
                                title: poll_campaign?.name ?? 'BettorEdge Predictions',
                                body: 'Play with me and win on BettorEdge!',
                                type_id: poll_campaign_id,
                                generator:'player',
                                link_type: 'user_generated_link',
                                link_sub_type: 'poll_link',
                                redirect_url: `https://play.bettoredge.com/competitions/trivia/${poll_campaign_id}`
                            }
                        })}
                        onComplete={() => console.log('')}
                    />
                    <View type='footer' style={{ padding:10 }}>
                        <Button
                            title='CLOSE'
                            type='close'
                            onPress={() => setLaunched(false)}
                        />
                    </View>
                </View>
                {authenticate.visible ?
                <View type='blur' style={{ position:'absolute', top:0, left:0, right:0, bottom:0, justifyContent:width > 600 ? 'center' : 'flex-end', alignItems:'center'}}>
                    <View float style={{ margin:10, width:auth_width }}>
                        <Authenticator
                            company_id={poll_campaign?.company_id ?? '1'}
                            auth_strategy_id={authenticate.auth_strategy_id??'3'}
                            onAuthenticated={async(authy_state:AuthenticatedProps) => {
                                await APIOverrides.authenticateApp({
                                    ...authy_state,
                                    distinct_id: auth_state.distinct_id,
                                    session_id: auth_state.session_id,
                                    authenticated: true     
                                }, { cache: true })
                                
                                setAuthState({
                                    ...auth_state,
                                    loaded: true,
                                    player_id: authy_state.player_id,
                                    authenticated: true,
                                    launched: true
                                })
                                setAuthenticate({ ...authenticate, visible: false });
                            }}
                            onClose={() => setAuthenticate({ ...authenticate, visible: false })}
                            source='embed'
                            referral_code={'tipoff'}
                            opt_in_url={'https://www.bettoredge.com/competition-rules'}
                        />
                    </View>
                </View>
                :<></>}
                {share.visible ?
                <View type='blur' style={{ position:'absolute', top:0, left:0, right:0, bottom:0, justifyContent:width > 600 ? 'center' : 'flex-end', alignItems:'center'}}>
                    <View float style={{ margin:10, width:auth_width }}>
                        <ShareWidget
                            player_id={auth_state.player_id as string | undefined}
                            title={share.share.title}
                            body={share.share.body}
                            redirect_url={share.share.redirect_url}
                            generator={share.share.generator}
                            link_type={share.share.link_type}
                            onSelectContact={() => console.log('')}
                            link_sub_type={share.share.link_sub_type}
                            onCancel={() => setShare({ visible: false })}
                            onShare={() => setShare({ visible: false })}
                        />
                    </View>
                </View>
                :<></>}
            </View>
            <Observer
                distinct_id={auth_state.distinct_id}
                session_id={auth_state.session_id}
                source='poll_embed'
            />
        </Modal>
    )
}

export default PollCampaignApp